module.exports = __webpack_public_path__ + "img/P150T_weapon_108.a1f317ff.png";